import classNames from 'classnames'

import { HTML_ELEMENT_PAGE_SCROLL_WRAPPER_ID } from '../../../constants/html'
import { useLayoutOverlayContext } from '../../../hooks'
import { ErrorPage } from '../../ErrorPage'
import { PageFooter } from '../PageFooter'

import * as styles from './Page.module.css'

function Page({
  children,
  contentRef,
  pagination,
  qaName,
  scrollWrapperRef,
  serverError,
}) {
  const { showGretaAIChat, showProductFruits, withModalsTray } =
    useLayoutOverlayContext()

  return serverError ? (
    <ErrorPage status={serverError.status} />
  ) : (
    <div
      className={classNames(styles.scrollWrapper, {
        [styles.withModalsTray]: withModalsTray,
        [styles.withSupportButtons]: showGretaAIChat || showProductFruits,
      })}
      id={HTML_ELEMENT_PAGE_SCROLL_WRAPPER_ID}
      ref={scrollWrapperRef}
    >
      <div className={styles.page} data-page={`${qaName}Page`}>
        <div className={styles.content} ref={contentRef}>
          {children}
        </div>
        <div>
          {pagination}
          <PageFooter />
        </div>
      </div>
    </div>
  )
}

export default Page
